import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { IndexPage } from './pages/IndexPage';
import { IndexPageGuest } from './pages/IndexPageGuest';
import { ConsolePage } from './pages/ConsolePage';

import SignInPage  from './pages/SignInPage';
import SignInPageGuest from './pages/SignInPageGuest';

import SignUpPage  from './pages/SignUpPage';
import CreateOrgPage  from './pages/CreateOrgPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

import './App.scss';
import AdminPage from './pages/admin/AdminPage';
import IndexHome from './pages/IndexHome';
import IndexHomePage from './pages/IndexHome';

import OrientationPage  from './pages/setup/OrientationPage';
import OrientationVideoPage  from './pages/setup/OrientationVideoPage';
import PreferencesPage  from './pages/setup/PreferencesPage';
import PersonaQuizPage  from './pages/setup/PersonaQuizPage';
import SystemBlockValidator from './pages/admin/SystemBlockValidator';
import VoiceTest from './pages/voiceTest';
import NotFound from './pages/NotFound';


//import { companyConfig } from './company/gds/config';// Multi-tenant config for Guttman Development Strategies (GDS)

//import './singleTabGuard';      // ✅ run guard first

function App() {
  console.log("APP.tsx loaded");
  //console.log("[App] Company config loaded:", companyConfig.companyName);  
  
  return (
      <Router>
        <div data-component="App">
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/validate" element={<SystemBlockValidator />} />// Robot Factory Assistant Rule checker
            <Route path="/console" element={<ConsolePage />} />
            <Route path="/" element={<SignInPage />} />
            <Route path="/guest" element={<SignInPageGuest /> } />
            <Route path="/ibot" element={<IndexPage />} />
             <Route path="/ibot-guest" element={<IndexPageGuest />} />
             <Route path="/cmw" element={<IndexHomePage />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/createorg" element={<CreateOrgPage />} />

            <Route path="/setup/orientation" element={<OrientationPage />} />
            <Route path="/setup/orientationVideo" element={<OrientationVideoPage />} />
            <Route path="/setup/preferences" element={<PreferencesPage />} />
            <Route path="/setup/persona" element={<PersonaQuizPage />} />
            <Route path="/voiceTest" element={<VoiceTest />} />      
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
  );
}

export default App;
